import { render, staticRenderFns } from "./RestoreFile.vue?vue&type=template&id=de82531e"
import script from "./RestoreFile.vue?vue&type=script&lang=js"
export * from "./RestoreFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports